import styles from './EmojiRain.module.scss';

const EmojiRain = () => {
    const emojis = ["🤩", "🍑", "🍌", "🔥", "👅", "💋", "🍾", "🍆", "🤩", "🍆", "💦", "🍑", "🍌", "🔥"] 

    return ( 
        <div className={styles.emojiRain}>

            {emojis.map((emoji, i)=>
            <div className={styles.emojiRain__emoji} key={i} >
                {emoji}
            </div>
            )}

        </div>
     );
}
 
export default EmojiRain;